module.exports = __webpack_public_path__ + "assets/extendify.6563d528.svg";